import { useBlogContext } from "./BlogPageProvider";
import { MOCK_ARRAY_5 } from "../../../lib/constants";
import { MaterialCardLoading } from "../../explore/material/cards/MaterialCardLoading";
import { LoadingSpin } from "../../global/loading/LoadingSpin";
import { useCallback, useRef } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { getBlogs } from "../../../api/listings";
import { useSnackbarContext } from "../../global/snackbar/SnackbarProvider";
import { ErrorSnackbar } from "../../global/snackbar";
import { BlogPageWebCard } from "./BlogPageWebCard";
import { BlogPageCard } from "./BlogPageCard";

export const BlogPageCards = () => {
  const { state, dispatch } = useBlogContext();
  const blogFilters = useSelector((state: RootState) => state.filters.blogs);
  const { setSnackbar } = useSnackbarContext();
  const observer = useRef<IntersectionObserver>();

  const handleGetMoreBlogs = useCallback(async () => {
    try {
      dispatch({ isLoadingMore: true });
      const blogs = await getBlogs(
        blogFilters.queryStringFilter,
        state.page + 1,
      );
      dispatch({
        blogs: { ...blogs, rows: [...state.blogs.rows, ...blogs.rows] },
        isLoadingMore: false,
        hasMoreBlogs: blogs.rows.length > 0,
        page: state.page + 1,
      });
    } catch (e) {
      const error = e as Error;
      setSnackbar(<ErrorSnackbar message={error.message} />);
      console.error(e);
    }
  }, [
    blogFilters.queryStringFilter,
    dispatch,
    setSnackbar,
    state.blogs.rows,
    state.page,
  ]);

  const lastBlogRef = useCallback(
    (node: HTMLDivElement) => {
      if (state.isLoadingMore) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && state.hasMoreBlogs) {
          void handleGetMoreBlogs();
        }
      });

      if (node) observer.current.observe(node);
    },
    [handleGetMoreBlogs, state.hasMoreBlogs, state.isLoadingMore],
  );

  if (state.isLoading) {
    return (
      <>
        {MOCK_ARRAY_5.map((item) => (
          <MaterialCardLoading key={item} />
        ))}
      </>
    );
  }

  return (
    <>
      {state.blogs.rows.map((blog, index) => {
        const isLastListing = state.blogs.rows.length - 1 === index;

        return (
          <div key={index} ref={isLastListing ? lastBlogRef : null}>
            <div className={"lg:hidden"}>
              <BlogPageCard blog={blog} />
            </div>

            <div key={index} className={"hidden lg:flex"}>
              <BlogPageWebCard blog={blog} />
            </div>
          </div>
        );
      })}
      {state.isLoadingMore && <LoadingSpin />}
    </>
  );
};
